var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 68,
    height: 48,
    rx: 13,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 68,
    height: 48,
    rx: 13,
    stroke: "#DCDFE3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 25C45 19.4772 40.5228 15 35 15C29.4772 15 25 19.4772 25 25C25 29.9913 28.6569 34.1284 33.4375 34.8785V27.8906H30.8984V25H33.4375V22.7969C33.4375 20.2906 34.9305 18.9063 37.2147 18.9063C38.3088 18.9063 39.4531 19.1016 39.4531 19.1016V21.5625H38.1922C36.9499 21.5625 36.5625 22.3334 36.5625 23.1242V25H39.3359L38.8926 27.8906H36.5625V34.8785C41.3431 34.1284 45 29.9913 45 25Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8926 27.8906L39.3359 25H36.5625V23.1242C36.5625 22.3333 36.9499 21.5625 38.1922 21.5625H39.4531V19.1016C39.4531 19.1016 38.3088 18.9062 37.2146 18.9062C34.9305 18.9062 33.4375 20.2906 33.4375 22.7969V25H30.8984V27.8906H33.4375V34.8785C33.9544 34.9595 34.4768 35.0001 35 35C35.5232 35.0001 36.0456 34.9595 36.5625 34.8785V27.8906H38.8926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(25 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.b726b2e9f1cc2b25856b21eb2d7c37df.svg";
export { ForwardRef as ReactComponent };